var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.icons[_vm.icon])}}),_c('div',{staticClass:"h-7 text-sm leading-7 text-gray ml-2 mr-4"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }